<cmps-wait-status *ngIf="hasPendingData"></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<div
    class="table-responsive"
    *ngIf="!hasPendingData && data != null"
>
    <table class="table table-striped table-sm table-bordered-no-cells">
        <thead class="thead-light">
            <tr>
                <th>{{ i18n._102_USER_NAME | translate }}</th>
                <th>{{ i18n._776_SCORECARD_NAME | translate }}</th>
                <th>{{ i18n._762_POINTS | translate }}</th>
                <th>{{ i18n._777_RANK | translate }}</th>
                <th>{{ i18n._817_BAND_NAME | translate }}</th>
                <th>View</th>
            </tr>
            <tr></tr>
        </thead>
        <tbody>
            <tr *ngFor="let i of data.items">
                <td>{{ i.username }}</td>
                <td>{{ i.scorecardName }}</td>
                <td>{{ i.points | number: '1.0-1' }}</td>
                <td>{{ i.rank }}</td>
                <td>{{ i.bandName }}</td>
                <td class="text-center">
                    <button
                        type="button"
                        class="cmps-btn-table"
                        (click)="showScorecard(i)"
                    >
                        <cmps-icon svgIcon="folder-outline"></cmps-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
